import { initializeApp } from 'firebase/app';
import { getToken, getMessaging, isSupported, onMessage } from 'firebase/messaging';

const firebaseConfig = {
	apiKey: 'AIzaSyCmw2eqxLgAiCuWB2dxkOkvZESzWhw0vAU',
	authDomain: 'futurelab-messaging-app.firebaseapp.com',
	projectId: 'futurelab-messaging-app',
	storageBucket: 'futurelab-messaging-app.appspot.com',
	messagingSenderId: '314357848790',
	appId: '1:314357848790:web:87a9c3def10b03e71fc777',
	measurementId: 'G-MHXK94NCJ9',
};

const firebase = initializeApp(firebaseConfig);

const getMessagingClient = async () => {
	if (typeof window === 'undefined') {
		return null;
	}

	const supported = await isSupported().catch(() => false);
	if (!supported) {
		console.log('[firebase] messaging unsupported in this browser');
		return null;
	}

	return getMessaging(firebase);
};

export const getFCMToken = async (setToken: any) => {
	try {
		const messaging = await getMessagingClient();
		if (!messaging) {
			return;
		}

		if (typeof Notification === 'undefined') {
			console.log('[firebase] Notification API unavailable');
			return;
		}

		const permission = await Notification.requestPermission();
		if (permission !== 'granted') {
			console.log('[firebase] Notification permission not granted');
			return;
		}

		const currentToken = await getToken(messaging, {
			vapidKey: 'BJjZFPewjK7erDBtcwoDJP-9f06qmdQ3VWMtAJuCeAwOYRCnXDs5SWY-58Wpg1yKh8dfHK4lRdcb_5Ca9eYiCHY',
		});
		if (currentToken) {
			// TODO: add the token to the backend
			setToken(currentToken);
		} else {
			// Show permission request UI
			console.log('No registration token available. Request permission to generate one.');
			// ...
		}
	} catch (err: any) {
		console.log('An error occurred while retrieving token. ', err);
	}
};

export const messageListener = async () => {
	const messaging = await getMessagingClient();
	if (!messaging) {
		return null;
	}

	return new Promise((resolve) => {
		onMessage(messaging, (payload: any) => {
			//check if user is on the page
			// if (document.visibilityState === 'hidden') {
			// 	//show notification
			// 	const notificationOptions = {
			// 		body: payload.data.body,
			// 		icon: './favicon.ico',
			// 		vibration: [200, 100, 200, 100, 200, 100, 200],
			// 		data: {
			// 			url: payload.data.link,
			// 		},
			// 	};
			// 	const notification = new Notification(payload.data.title, notificationOptions);
			// 	notification.onclick = (e) => {
			// 		e.preventDefault();
			// 		notification.close();
			// 	};
			// 	//show notification
			// 	if (Notification.permission === 'granted') {
			// 		navigator.serviceWorker.getRegistration().then((reg) => {
			// 			reg?.showNotification(payload.data.title, notificationOptions);
			// 		});
			// 	}
			// }
			if (typeof navigator !== 'undefined' && navigator.vibrate) {
				navigator.vibrate([200, 100]);
			}
			resolve(payload);
		});
	});
};

export default firebase;
